import { render, staticRenderFns } from "./SelecoesEdit.vue?vue&type=template&id=1a85cfbc&scoped=true"
import script from "./SelecoesEdit.vue?vue&type=script&lang=js"
export * from "./SelecoesEdit.vue?vue&type=script&lang=js"
import style0 from "./SelecoesEdit.vue?vue&type=style&index=0&id=1a85cfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85cfbc",
  null
  
)

export default component.exports